import { connect } from 'react-redux'
import {
    getSelectedCenter,
    canOnlyViewOutlet,
    canViewOutlet,
    hasPromoActivated,
    getIsMkToolsCenter,
    getIsLowesCenter,
    getMktoolsShippingCenter,
    getIsIkeaCenter,
    getPromoBanners,
    getIsVirtualVisitEnabled,
    hasPromotionLandingActivated,
    getHQCenterId,
    getShowroomCenterId,
    getLowesCenterId,
    isEuropeOrIberia,
    isUsaOrCanada,
    getCenterData,
    getWarehoseCenterId,
    isOnlyUsaSalesOrg,
    getIsLoadingDriUsaOrderLimit,
    getDriUsaOrderLimit,
    getDRIUSACenterId,
    isAustralianCenter,
    isSelectedCenterAvailableToBuyEclosProducts
} from '../../store/centers/reducers'
import {changeCenter, changeFirstCenterFromSalesOrg, setMkToolsShippingCenter} from '../../store/centers/actions'
import Catalog from './Catalog'
import { injectIntl } from 'react-intl'
import { fetchProductsFavourite, fetchDeviatedDescriptions, fetchProductsDiscounts } from '../../store/products/actions'
import { getProductsIdFavourite, canViewPricesPhase3, getPromotionsProductIds } from '../../store/products/reducers'
import {
    getIsLogged,
    getToken,
    getSalesOrg,
    getUserType,
    getImpersonatedBy,
    getIsAdmin,
    getHaveUserSeenOutletModal,
    getIsMagazineMk,
    getCommonParams,
    getPriceListAtSelectedCenter,
    getVirtualVisitURL,
    getUserPriceList,
    canViewRocketPromotion,
    canViewRockMasterPromotion,
    canViewEarthicPromotion,
    canViewHybriqPromotion,
    canViewSilestonePromotionXM,
    getNaturalStoneViewingPermissions,
    canViewSilestoneContainerPromotion,
    canViewSumaPromotion,
    canViewWorldMallWeekPromotion,
    getCustomerByFabricator,
    isPriorityCustomerForEclos, canViewNaturalStoneSection, canViewOutletAustraliaPromotion
} from '../../store/login/reducers'
import { withRouter } from 'react-router-dom'
import { getShippingAddressesCenters, isLoadingShippingAddress } from '../../store/shipping-addresses/reducers'
import { fetchShippingAddresses } from '../../store/shipping-addresses/actions'
import {
    getBlockOrdersFromMktoolsDriUsa,
    getCurrentLocation,
    getHideAllBannerCatalog,
    getLanguage,
    getMaintenanceScheduledText,
    getShowOnlineVisitBanner,
    canViewEclosBrandInEurope,
    canViewDektonArtikPromotion
} from '../../store/ui/reducers'
import { loginRequired } from '../../store/login/actions'
import { getBannerDescription, getBannerTitle, getPromotionLateralBanner, getPromotionLink } from '../../store/promotions/reducers'
import {getAdaptedFormat} from "../../helpers";
import { dispatchPushURL, setIsSilestoneBrandVisible } from '../../store/ui/actions'
import moment from 'moment'
const mapStateToProps = (state, { match }) => {
    return {
        token: getToken(state),
        fullView: getIsLogged(state),
        center: getSelectedCenter(state) ? getSelectedCenter(state) : 'near',
        key: getSelectedCenter(state) + '-' + match.params.outlet,
        outlet: match.params.outlet === 'outlet' || match.params.outlet === 'hqoutlet' ? 'outlet' : '',
        hq: typeof match.params.outlet === 'string' && match.params.outlet.startsWith('hq'),
        canOnlyViewOutlet: canOnlyViewOutlet(state),
        isLogged: getIsLogged(state),
        isAdmin: getIsAdmin(state),
        salesOrg: getSalesOrg(state),
        productsIdFavourite: getProductsIdFavourite(state),
        // promotionsProductIds: getPromotionsProductIds(state, match.params.outlet),
        userType: getUserType(state),
        canViewOutlet: canViewOutlet(state),
        canViewPricesPhase3: canViewPricesPhase3(state),
        hasPromoActivated: hasPromoActivated(state),
        hasPromotionLandingActivated: hasPromotionLandingActivated(state),
        promotionLateralBanner: getPromotionLateralBanner(state),
        promotionLink: getPromotionLink(state),
        promoBanners: getPromoBanners(state),
        isMkToolsCenter: getIsMkToolsCenter(state),
        impersonatedBy: getImpersonatedBy(state),
        isLowesCenter: getIsLowesCenter(state),
        isIkeaCenter: getIsIkeaCenter(state),
        shippingAddressesCenters: getShippingAddressesCenters(state),
        isLoadingShippingAddresses: isLoadingShippingAddress(state),
        mktoolsShippingCenter: getMktoolsShippingCenter(state),
        alreadyClosedOutletModal: getHaveUserSeenOutletModal(state),
        isMagazineMk: getIsMagazineMk(state),
        language: getLanguage(state),
        virtualVisitiEnabled: getIsVirtualVisitEnabled(state),
        URLVirtualVisit: getVirtualVisitURL(state),
        priceList: getPriceListAtSelectedCenter(state),
        userPriceList: getUserPriceList(state),
        commonParamsAnalytics: getCommonParams(state),
        maintenanceScheduledText: getMaintenanceScheduledText(state),
        promotionBannerTitle: getBannerTitle(state),
        promotionBannerDescription: getBannerDescription(state),
        HQCenterId: getHQCenterId(),
        showroomCenterId: getShowroomCenterId(),
        adaptedFormat: (format, params) => getAdaptedFormat(format, params, state),
        LowesCenterId: getLowesCenterId(),
        isHideAllBannerCatalog: getHideAllBannerCatalog(state),
        isUsaOrCanada: isUsaOrCanada(state),
        showBannerPromo: new moment() < moment('2022-11-18 18:00') && isEuropeOrIberia(state),
        canViewRocketPromotion: canViewRocketPromotion(state),
        currentLocation: getCurrentLocation(state),
        centerData: getCenterData(state),
        canViewRockMasterPromotion: canViewRockMasterPromotion(state),
        canViewEarthicPromotion: canViewEarthicPromotion(state),
        canViewHybriqPromotion: canViewHybriqPromotion(state),
        isWarehouse: getSelectedCenter(state) == getWarehoseCenterId(),
        canViewSilestonePromotionXM: canViewSilestonePromotionXM(state),
        naturalStoneViewingPermissions: getNaturalStoneViewingPermissions(state),
        isOnlyUsaSalesOrg: isOnlyUsaSalesOrg(state),
        canViewSilestoneContainerPromotion: canViewSilestoneContainerPromotion(state),
        canViewSumaPromotion: canViewSumaPromotion(state),
        canViewWorldMallWeekPromotion: canViewWorldMallWeekPromotion(state),
        customerByFabricator: getCustomerByFabricator(state),
        isPriorityCustomerForEclos: isPriorityCustomerForEclos(state),
        showOnlineVisitBanner: getShowOnlineVisitBanner(state),
        isLoadingDriUsaOrderLimit: getIsLoadingDriUsaOrderLimit(state),
        driUsaOrderLimit: getDriUsaOrderLimit(state),
        driUsaCenterId: getDRIUSACenterId(state),
        canViewNaturalStoneSection: canViewNaturalStoneSection(state),
        canViewOutletAustraliaPromotion: canViewOutletAustraliaPromotion(state),
        getBlockOrdersFromMktoolsDriUsa: getBlockOrdersFromMktoolsDriUsa(state),
        isAustralianCenter: isAustralianCenter(state),
        isEuropeOrIberia: isEuropeOrIberia(state),
        canViewEclosBrandInEurope: canViewEclosBrandInEurope(state),
        isSelectedCenterAvailableToBuyEclosProducts: isSelectedCenterAvailableToBuyEclosProducts(state),
        canViewDektonArtikPromotion: canViewDektonArtikPromotion(state)
    }
}
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        redirect: url => {
            dispatch(dispatchPushURL(url))
        },
        changeCenter: center => {
            dispatch(changeCenter(center))
        },
        changeCenterFromSalesOrg: salesOrg => {
            dispatch(changeFirstCenterFromSalesOrg(salesOrg))
        },
        fetchProductsFavourite: () => {
            dispatch(fetchProductsFavourite())
        },
        fetchShippingAddresses: () => {
            dispatch(fetchShippingAddresses())
        },
        setMkToolsShippingCenter: mktoolsShippingCenter => {
            dispatch(setMkToolsShippingCenter(mktoolsShippingCenter))
        },
        dontShowOutletModalAgain: () => {
            dispatch({ type: 'DONT_SHOW_OUTLET_MODAL_AGAIN' })
        },
        fetchDeviatedDescriptions: () => dispatch(fetchDeviatedDescriptions()),
        loginRequired: (callbackSalesOrg = null) => {
            dispatch(loginRequired(null, null, callbackSalesOrg))
        },
        sendSearchProduct: (term) => {
            dispatch({type: 'SEND_SEARCH_PRODUCT', term})
        },
        setIsSilestoneBrandVisible: (isVisible) => {
            dispatch(setIsSilestoneBrandVisible(isVisible))
        },
        triggerCatalogFilter: (sectionType, filterName, selectedItems) => {
            dispatch({
                type: 'APPLY_CATALOG_FILTER',
                payload: {
                    sectionType,
                    filterName,
                    selectedItems
                }
            })
        },
        triggerCatalogSortFilter: (sectionType, filterName) => {
            dispatch({
                type: 'APPLY_CATALOG_SORT_FILTER',
                payload: {
                    sectionType,
                    filterName
                }
            })
        },
        setIsInOutletBrazil: (isInOutletBrazil) => dispatch({type:'SET_IS_IN_OUTLET_BRAZIL', isInOutletBrazil:isInOutletBrazil}),
        setIsInOutletSpain: (isInOutletSpain) => dispatch({type:'SET_IS_IN_OUTLET_SPAIN', isInOutletSpain:isInOutletSpain}),
        resetOutletFlags: () => dispatch({type: 'RESET_OUTLET_FLAGS'})
    }
}
const CatalogContainer = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Catalog)
)

export default injectIntl(CatalogContainer)
